import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import br from "react-phone-number-input/locale/pt-BR.json";
import "./styles.css";

export default function PhoneNumber(props) {
  return <PhoneInput {...props} labels={br} limitMaxLength />;
}
